

























import { computed, defineComponent } from '@vue/composition-api';
import FindMarkerButton from '@/components/map/FindMarkerButton.vue';
import OfflineMapButton from '@/components/map/OfflineMapButton.vue';
import { FIELDS_MAP_ID } from '@/constants';
import { FieldRow } from '@/store/types';

export default defineComponent({
	components: {
		OfflineMapButton,
		FindMarkerButton,
	},
	props: {
		fieldRow: {
			type: Object as () => FieldRow,
			required: true,
		},
	},
	setup({ fieldRow }, { root }) {
		const color = computed<string>(() => {
			const activeFieldId = root.$store.getters['fieldsView/getActiveFieldId'];
			return activeFieldId === fieldRow.id ? 'blue' : '';
		});

		const handleCardClick = () => {
			root.$router.push(`/field/${fieldRow.id}`);
		};

		return {
			color,
			handleCardClick,
			FIELDS_MAP_ID,
		};
	},
});
